import Vue from 'vue'
import App from './App.vue'
// import browserDetect from "vue-browser-detect-plugin";
// Vue.use(browserDetect);
// Vue.config.productionTip = false

// import VueGtag from "vue-gtag";
//
// Vue.use(VueGtag, {
//   config: { id: "GTM-TDBNC63X" }
// });
import './assets/fonts/font.css'
new Vue({
  render: h => h(App),
}).$mount('#app')
